import {
  ResolutionsListFiltersContext,
  useResolutionsListFilterDatePickers
} from '@bo-hooks/resolutions/resolutionsList';
import { MultiSelectFilter } from '@library/components/filters';
import { PrizepicksDateRange } from '@library/components/datePicker/PrizepicksDateRange';
import { ResetIconButton } from '@library/components/buttons';
import { useContext } from 'react';

export const ResolutionFilters = () => {
  const {
    createdAtFromPickerOpen,
    createdAtToPickerOpen,
    onCreatedAtFromPickerStatusChange,
    onCreatedAtToPickerStatusChange
  } = useResolutionsListFilterDatePickers();

  const {
    adminUserOptions,
    onAdminUserChange,
    onCreatedAtChange,
    onResetFilters,
    onResolutionStatusChange,
    resolutionListFilters,
    resolutionStatusOptions
  } = useContext(ResolutionsListFiltersContext);

  const { adminUsers, createdAtFromDate, createdAtToDate, resolutionStatuses } =
    resolutionListFilters;

  return (
    <div className="flex flex-wrap items-center gap-4 py-6">
      <div className="shrink-0">
        <MultiSelectFilter
          label="Admin Users"
          onChange={onAdminUserChange}
          options={adminUserOptions}
          selectedValues={adminUsers}
          size="medium"
          testId="resolution-admin-users"
        />
      </div>
      <div className="shrink-0" data-testid="created-at-date-range">
        <PrizepicksDateRange
          endDate={createdAtToDate?.toJSDate()}
          endDatePlaceholder="Created At To"
          endOpen={createdAtToPickerOpen}
          handleChange={onCreatedAtChange}
          maxDate={new Date()}
          setEndOpen={onCreatedAtToPickerStatusChange}
          setStartOpen={onCreatedAtFromPickerStatusChange}
          startOpen={createdAtFromPickerOpen}
          startDatePlaceholder="Created At From"
          startDate={createdAtFromDate?.toJSDate()}
        />
      </div>
      <div className="shrink-0">
        <MultiSelectFilter
          label="Statuses"
          onChange={onResolutionStatusChange}
          options={resolutionStatusOptions}
          selectedValues={resolutionStatuses}
          size="medium"
          testId="resolution-admin-users"
        />
      </div>
      <ResetIconButton
        className="disabled:text-soClean-140 !m-0 shrink-0 basis-28 !p-0"
        disabled={false}
        label="Reset Filters"
        onClick={onResetFilters}
      />
    </div>
  );
};
